import { useEffect } from 'react';

const OOdriveCallback = () => {
  useEffect(() => {
    window.parent.postMessage('closeModal', window.location.origin);
  }, []);

  return (
    <div>Vous pouvez fermer cette fenêtre maintenant.</div>
  );
};

export default OOdriveCallback;